<template>
	<section ref="el" data-component="legal-content" data-section-intersect="light">
		<div class="row align-center">
			<div class="xxlarge-9 medium-12 small-14 xsmall-15 col">
				<RichText :blocks="content" />
			</div>
		</div>
	</section>
</template>

<script setup>
import { RichText } from '~/components/primitives'

const props = defineProps({
	content: { type: Array, default: () => [] },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='legal-content'] {
	position: relative;
	padding-bottom: rs(140);

	background-color: var(--color-darkBrown);

	:deep(h2) {
		position: relative;
		margin-bottom: rs(32);
		margin-top: rs(86);

		@include title-5;
		color: var(--color-yellow);
		text-align: center;
		text-transform: uppercase;

		&:first-of-type {
			margin-top: 0;
		}
	}

	:deep(ul) {
		position: relative;
		list-style: disc;
		margin-left: 1em;
		margin-top: 1em;
	}

	:deep(p),
	:deep(li) {
		position: relative;
		margin-bottom: 1em;
		@include body-2;
		color: var(--color-lightYellow);
	}
}
</style>
